import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chatUnreadBadgeSx } from '../chat/chatUnreadBadgeStyles';

/** Nav action badge for booking needs-action totals (same signal language as chat unread). */
interface BookingNeedsActionNavBadgeProps {
  count: number;
  /** i18n key for aria-label; receives `{ count }`. */
  labelKey?: string;
  labelDefault?: string;
}

function formatCount(count: number): string {
  if (count > 99) {
    return '99+';
  }
  return String(count);
}

const BookingNeedsActionNavBadge: React.FC<BookingNeedsActionNavBadgeProps> = ({
  count,
  labelKey = 'tutorBookingRequests.needsActionNavBadge',
  labelDefault = '{{count}} need action',
}) => {
  const { t } = useTranslation();

  if (count <= 0) {
    return null;
  }

  return (
    <Box
      component="span"
      role="status"
      aria-live="polite"
      aria-label={t(labelKey, labelDefault, { count })}
      sx={chatUnreadBadgeSx('nav')}
    >
      {formatCount(count)}
    </Box>
  );
};

/** @deprecated Prefer BookingNeedsActionNavBadge; kept for existing tutor imports. */
const TutorBookingNeedsActionNavBadge = BookingNeedsActionNavBadge;

export { BookingNeedsActionNavBadge };
export default TutorBookingNeedsActionNavBadge;
